// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-information-content {
  padding: 0;
}
.license-information-content .license-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid rgba(20, 42, 49, 0.1);
}
.license-information-content .license-info-row:last-of-type {
  border-bottom: none;
}
.license-information-content .license-info-row .license-info-label {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  font-weight: 600;
  color: #142A31;
  font-size: 14px;
  min-width: 140px;
  opacity: 0.8;
}
.license-information-content .license-info-row .license-info-value {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  font-size: 14px;
  color: #142A31;
  text-align: right;
  flex: 1 1;
  margin-left: 16px;
  font-weight: 600;
}
.license-information-content .license-info-row .license-info-value.status-active {
  color: #28A745;
  background: rgba(40, 167, 69, 0.1);
  padding: 4px 12px;
  border-radius: 16px;
  display: inline-block;
}
.license-information-content .license-info-row .license-info-value.status-expired {
  color: #FF5555;
  background: rgba(255, 85, 85, 0.1);
  padding: 4px 12px;
  border-radius: 16px;
  display: inline-block;
}
.license-information-content .license-info-row .license-info-value.status-pending {
  color: #ffc107;
  background: rgba(255, 193, 7, 0.1);
  padding: 4px 12px;
  border-radius: 16px;
  display: inline-block;
}

.license-loading {
  padding: 60px 24px;
  text-align: center;
}
.license-loading .loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(64, 160, 193, 0.2);
  border-top: 3px solid #40A0C1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}
.license-loading .loading-text {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  color: #142A31;
  font-size: 14px;
  opacity: 0.7;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.license-error {
  padding: 40px 24px;
  text-align: center;
}
.license-error .error-message {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  color: #FF5555;
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 1.21em;
}`, "",{"version":3,"sources":["webpack://./src/components/LicenseInformationModal/licenseInformationModal.scss"],"names":[],"mappings":"AAEA;EACC,UAAA;AADD;AAGC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;AADF;AAGE;EACC,mBAAA;AADH;AAIE;EACC,yFAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAFH;AAKE;EACC,yFAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAHH;AAKG;EACC,cAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AAHJ;AAMG;EACC,cAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AAJJ;AAOG;EACC,cAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AALJ;;AAWA;EACC,kBAAA;EACA,kBAAA;AARD;AAUC;EACC,WAAA;EACA,YAAA;EACA,yCAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AARF;AAWC;EACC,yFAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AATF;;AAaA;EACC;IAAK,uBAAA;EATJ;EAUD;IAAO,yBAAA;EAPN;AACF;AASA;EACC,kBAAA;EACA,kBAAA;AAPD;AASC;EACC,yFAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAPF","sourcesContent":["@import '../../styles/popup-design-system.scss';\n\n.license-information-content {\n\tpadding: 0;\n\n\t.license-info-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tpadding: 16px 0;\n\t\tborder-bottom: 1px solid rgba(popup-color('text-primary'), 0.1);\n\n\t\t&:last-of-type {\n\t\t\tborder-bottom: none;\n\t\t}\n\n\t\t.license-info-label {\n\t\t\tfont-family: popup-typo('font-family');\n\t\t\tfont-weight: 600;\n\t\t\tcolor: popup-color('text-primary');\n\t\t\tfont-size: popup-typo('body-size');\n\t\t\tmin-width: 140px;\n\t\t\topacity: 0.8;\n\t\t}\n\n\t\t.license-info-value {\n\t\t\tfont-family: popup-typo('font-family');\n\t\t\tfont-size: popup-typo('body-size');\n\t\t\tcolor: popup-color('text-primary');\n\t\t\ttext-align: right;\n\t\t\tflex: 1;\n\t\t\tmargin-left: 16px;\n\t\t\tfont-weight: 600;\n\n\t\t\t&.status-active {\n\t\t\t\tcolor: popup-color('btn-success');\n\t\t\t\tbackground: rgba(popup-color('btn-success'), 0.1);\n\t\t\t\tpadding: 4px 12px;\n\t\t\t\tborder-radius: 16px;\n\t\t\t\tdisplay: inline-block;\n\t\t\t}\n\n\t\t\t&.status-expired {\n\t\t\t\tcolor: popup-color('btn-danger');\n\t\t\t\tbackground: rgba(popup-color('btn-danger'), 0.1);\n\t\t\t\tpadding: 4px 12px;\n\t\t\t\tborder-radius: 16px;\n\t\t\t\tdisplay: inline-block;\n\t\t\t}\n\n\t\t\t&.status-pending {\n\t\t\t\tcolor: #ffc107;\n\t\t\t\tbackground: rgba(255, 193, 7, 0.1);\n\t\t\t\tpadding: 4px 12px;\n\t\t\t\tborder-radius: 16px;\n\t\t\t\tdisplay: inline-block;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.license-loading {\n\tpadding: 60px 24px;\n\ttext-align: center;\n\n\t.loading-spinner {\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tborder: 3px solid rgba(popup-color('btn-primary'), 0.2);\n\t\tborder-top: 3px solid popup-color('btn-primary');\n\t\tborder-radius: 50%;\n\t\tanimation: spin 1s linear infinite;\n\t\tmargin: 0 auto 20px;\n\t}\n\n\t.loading-text {\n\t\tfont-family: popup-typo('font-family');\n\t\tcolor: popup-color('text-primary');\n\t\tfont-size: popup-typo('body-size');\n\t\topacity: 0.7;\n\t}\n}\n\n@keyframes spin {\n\t0% { transform: rotate(0deg); }\n\t100% { transform: rotate(360deg); }\n}\n\n.license-error {\n\tpadding: 40px 24px;\n\ttext-align: center;\n\n\t.error-message {\n\t\tfont-family: popup-typo('font-family');\n\t\tcolor: popup-color('btn-danger');\n\t\tmargin-bottom: 24px;\n\t\tfont-size: popup-typo('body-size');\n\t\tline-height: popup-typo('body-line-height');\n\t}\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
